/*@flow*/
import getFunctionName from './getFunctionName';

function replacer(_key: any, value: any) {
  if (typeof value === 'function') {
    return getFunctionName(value);
  }
  return value;
}

export default function stringify(x: any): string {
  try {
    // handle "Converting circular structure to JSON" error
    return JSON.stringify(x, replacer, 2);
  } catch (e) {
    return String(x);
  }
}
